import React, { useState } from "react";
import { Switch } from "@my-scoot/component-library-legacy";
import InfoIcon from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";

import style from "./ContentRow.module.css";

import VdoCipherVideo from "./VdoCipherVideo";
import { Video } from "../PrivateVideo/PrivateVideo";
import { onOpenDrmCompatibilityExplanation } from "utils/urlUtils";

function DrmVideo({ content }) {
  const [showDrmVideo, setShowDrmVideo] = useState(false);
  const onChange = (event, checked) => setShowDrmVideo(checked);

  return (
    <div>
      <div className={style.drmSwitchWrap}>
        <Switch checked={showDrmVideo} onChange={onChange} />
        <span>Show DRM Video</span>
        <IconButton
          onClick={onOpenDrmCompatibilityExplanation}
          className="no_padding"
        >
          <InfoIcon />
        </IconButton>
      </div>
      {showDrmVideo ? (
        <VdoCipherVideo content={content} />
      ) : (
        <Video url={content.content} width="100%" />
      )}
    </div>
  );
}

export default DrmVideo;
